import Debouncer from 'middlewares/Debouncer';
import { getTasks } from './ActionCreator';
import { LoanOriginationSystemTasksFiltersActionTypes } from './Filters/ActionTypes';

export default Debouncer(() => {
  return getTasks();
}, [LoanOriginationSystemTasksFiltersActionTypes.SetSearchInputValue]);
